import React, { useState } from "react";
import Header from "../Section/Header";
import Footer from "../Section/Footer";
import { X } from "lucide-react";
import { Modal } from "react-bootstrap";
import sucess_gif from "../../Assests/sucess_gif.gif";
import {
  server_post_data,
  support_link,
} from "../../ServiceConnection/serviceconnection";
import Loader from "../Section/Loader";
export default function Support() {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [formData, setFormData] = useState({
    subject: "",
    email: "",
    phone: "",
    category: "",
  });
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const maxChars = 1000;

  const validate = () => {
    const newErrors = {};
    if (!formData.subject.trim()) newErrors.subject = "Subject is required.";
    if (!formData.email.trim() || !/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Valid email is required.";
    if (!formData.category) newErrors.category = "Please select a category.";
    if (!message || message.trim().length < 50)
      newErrors.message = "Message must be at least 50 characters.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    if (e.target.value.length <= maxChars) {
      setMessage(e.target.value);
    }
    setErrors({ ...errors, message: "" });
  };

  const handleDynamic = async (type) => {
    setIsLoading(true);
    const fd = new FormData();
    fd.append("subject", formData.subject);
    fd.append("email", formData.email);
    fd.append("phone", formData.phone);
    fd.append("category", formData.category);
    fd.append("message", message);

    await server_post_data(support_link, fd)
      .then((Response) => {
        setIsLoading(false);
        setShowSuccessModal(true);

        setFormData({
          subject: "",
          email: "",
          phone: "",
          category: "",
        });
        setMessage("");
        setTimeout(() => {
          setShowSuccessModal(false);
        }, 2000);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
     handleDynamic()
    }
  };

  return (
    <>
      <Header />
      {isLoading && <Loader />}
      <div className="bg-gradient-to-br from-slate-900 via-purple-900 to-indigo-900 bg-[length:300%_300%] animate-gradient-flow">
        <section className="max-w-[700px] mx-auto py-10 px-4">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400">
              🛠️ Help & Support
            </h2>
            <p className="text-lg text-purple-300">
              Need help? Fill the form below and we’ll get back to you shortly.
            </p>
          </div>

          <form
            className="bg-slate-800/50 backdrop-blur-sm p-6 rounded-lg border border-purple-700/50 space-y-5"
            onSubmit={handleSubmit}
          >
            {/* Subject */}
            <div>
              <label className="text-purple-200 text-sm font-medium block mb-1">
                Subject <span className="text-red-400">*</span>
              </label>
              <input
                type="text"
                value={formData.subject}
                className="w-full h-11 rounded-md px-4 bg-slate-700/50 text-purple-100 border border-purple-600"
                placeholder="Enter subject"
                onChange={(e) => {
                  setFormData({ ...formData, subject: e.target.value });
                  setErrors((prev) => ({ ...prev, subject: "" }));
                }}
              />
              {errors.subject && (
                <span className="text-sm text-red-400">{errors.subject}</span>
              )}
            </div>

            {/* Email */}
            <div>
              <label className="text-purple-200 text-sm font-medium block mb-1">
                Email <span className="text-red-400">*</span>
              </label>
              <input
                type="email"
                value={formData.email}
                className="w-full h-11 rounded-md px-4 bg-slate-700/50 text-purple-100 border border-purple-600"
                placeholder="Enter your email"
                onChange={(e) => {
                  setFormData({ ...formData, email: e.target.value });
                  setErrors((prev) => ({ ...prev, email: "" }));
                }}
              />
              {errors.email && (
                <span className="text-sm text-red-400">{errors.email}</span>
              )}
            </div>

            {/* Phone (optional) */}
            <div>
              <label className="text-purple-200 text-sm font-medium block mb-1">
                Phone (optional)
              </label>
              <input
                type="tel"
                value={formData.phone}
                className="w-full h-11 rounded-md px-4 bg-slate-700/50 text-purple-100 border border-purple-600"
                placeholder="Enter phone number"
                onChange={(e) => {
                  setFormData({ ...formData, phone: e.target.value });
                }}
              />
            </div>

            {/* Category */}
            <div>
              <label className="text-purple-200 text-sm font-medium block mb-1">
                Issue Category <span className="text-red-400">*</span>
              </label>
              <select
                className="w-full h-11 rounded-md px-4 bg-slate-700/50 text-purple-100 border border-purple-600"
                value={formData.category}
                onChange={(e) => {
                  setFormData({ ...formData, category: e.target.value });
                  setErrors((prev) => ({ ...prev, category: "" }));
                }}
              >
                <option value="">-- Select Category --</option>
                <option value="Technical">Technical</option>
                <option value="Payment">Payment</option>
                <option value="Feedback">Feedback</option>
                <option value="Other">Other</option>
              </select>
              {errors.category && (
                <span className="text-sm text-red-400">{errors.category}</span>
              )}
            </div>

            {/* Message */}
            <div>
              <div className="flex justify-between">
                <label className="text-purple-200 text-sm font-medium block mb-1">
                  Message <span className="text-red-400">*</span>
                </label>
                <span
                  className={`text-xs ${
                    message.length >= maxChars
                      ? "text-red-400"
                      : "text-purple-300"
                  }`}
                >
                  {message.length} / {maxChars}
                </span>
              </div>
              <textarea
                value={message}
                onChange={(e) => {
                  if (e.target.value.length <= maxChars) {
                    setMessage(e.target.value);
                  }
                  setErrors((prev) => ({ ...prev, message: "" }));
                }}
                rows={4}
                maxLength={maxChars}
                placeholder="Describe your issue (min 50 characters)"
                className="w-full rounded-md px-4 py-2 bg-slate-700/50 text-purple-100 border border-purple-600 resize-none"
              />
              {errors.message && (
                <span className="text-sm text-red-400">{errors.message}</span>
              )}
            </div>

            <button
              type="submit"
              className="w-full h-11 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white font-semibold rounded-full transition"
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </form>
        </section>
      </div>

      {/* ✅ Success Modal */}
      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        centered
        backdrop="static"
        keyboard={false}
        className="custom-modal-success"
      >
        <Modal.Body className="text-center bg-slate-800 text-white p-0 rounded-lg">
          <div className="flex flex-col items-center justify-center px-3 py-4 relative">
            <X
              size={28}
              className="cursor-pointer absolute right-[0.2rem] md:right-[-2rem] top-[-2.2rem] md:top-[-2rem] rounded-full bg-white text-black p-[5px] shadow-md hover:scale-110 transition"
              onClick={() => setShowSuccessModal(false)}
            />
            <img src={sucess_gif} alt="Success" className="h-[180px] mb-3" />
            <h5 className="text-[22px] font-bold text-green-400 mb-2">
              Submitted Successfully!
            </h5>
            <p className="text-[14px] text-white/80 max-w-md">
              Thank you for contacting us. We’ll get back to you shortly.
            </p>
          </div>
        </Modal.Body>
      </Modal>

      <Footer />
    </>
  );
}
